// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from 'react-router-dom';
// import config from "../config/config";

// const AddStreamForm = () => {
//   const navigate = useNavigate()

//   const [colleges, setColleges] = useState([]);
//   const [courses, setCourses] = useState([]);
//   const [selectedCollege, setSelectedCollege] = useState("");
//   const [formData, setFormData] = useState({
//     collegeId: "",
//     courseId: "",  // Added courseId here to send it properly
//     courseName: "",
//     streamsName: "",
//     streamsFee: "",
//     applicationDate: "",
//   });

//   // Fetch colleges on component mount
//   useEffect(() => {
//     axios
//       .get(`${config.API_BASE_URL}/api/admin/get_collegespage`)
//       .then((res) => setColleges(res.data.collegePages || []))
//       .catch((err) => console.error("Error fetching colleges:", err));
//   }, []);

//   // Fetch courses when college changes
//   const handleCollegeChange = async (e) => {
//     const collegeId = e.target.value;
//     setSelectedCollege(collegeId);
//     setFormData({ ...formData, collegeId, courseId: "" }); // Reset courseId when college changes

//     try {
//       const response = await axios.get(`${config.API_BASE_URL}/api/admin/college_page_course_details/${collegeId}`);
//       setCourses(Array.isArray(response.data.pageCourseDetails.coursesDeatils) ? response.data.pageCourseDetails.coursesDeatils : []);
//       console.log("Fetched Courses:", response.data.pageCourseDetails.coursesDeatils);
//     } catch (error) {
//       console.error("Error fetching courses:", error);
//       setCourses([]); // Fallback to an empty array in case of an error
//     }
//   };

//   // When course is selected, update courseId
//   const handleCourseChange = (e) => {
//     const courseId = e.target.value; // Get the selected course ID
//     const selectedCourse = courses.find(course => course._id === courseId); // Find the selected course object
//     setFormData({ ...formData, courseId, courseName: selectedCourse?.courses || "" });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       // Send the form data including courseId
//       const res = await axios.post(`${config.API_BASE_URL}/api/admin/streams`, formData);
//       if (res.data.code === 201) {
//         alert('Stream added successfully!');
//         // navigate("/admin/stream");
//         console.log(res.data);
//       } else {
//           alert('Error creating course');
//           console.error(res.data);
//       }
//       // setCourses([]);
//       // setSelectedCollege("");
//     } catch (error) {
//       console.error("Error adding stream:", error);
//     }
//   };

//   return (
//     <div className="container mt-5 pt-5">
//      <div className="row">
//       <div className="col-lg-2"></div>
//       <div className="col-lg-10">
//       <h2 className="mb-4">Add Stream</h2>
//       <form onSubmit={handleSubmit} className="p-4 border rounded shadow">
//         <div className="mb-3">
//           <label className="form-label">Select College:</label>
//           <select
//             className="form-control"
//             name="collegeId"
//             value={selectedCollege}
//             onChange={handleCollegeChange}
//             required
//           >
//             <option value="">Select a college</option>
//             {colleges.map((college) => (
//               <option key={college._id} value={college._id}>
//                 {college.collegeName}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="mb-3">
//           <label className="form-label">Select Course:</label>
//           <select
//             className="form-control"
//             name="courseId"
//             value={formData.courseId}
//             onChange={handleCourseChange}  // Use the updated function to select course
//             required
//             disabled={!selectedCollege}
//           >
//             <option value="">Select a course</option>
//             {Array.isArray(courses) &&
//               courses.map((course) => (
//                 <option key={course._id} value={course._id}>  {/* Now using course._id */}
//                   {course.courses} - {course.fees}
//                 </option>
//               ))}
//           </select>
//         </div>

//         <div className="mb-3">
//           <label className="form-label">Stream Name:</label>
//           <input
//             type="text"
//             className="form-control"
//             name="streamsName"
//             value={formData.streamsName}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div className="mb-3">
//           <label className="form-label">Stream Fee:</label>
//           <input
//             type="text"
//             className="form-control"
//             name="streamsFee"
//             value={formData.streamsFee}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div className="mb-3">
//           <label className="form-label">Application Date:</label>
//           <input
//             type="date"
//             className="form-control"
//             name="applicationDate"
//             value={formData.applicationDate}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <button type="submit" className="btn btn-primary">
//           Add Stream
//         </button>
//       </form>
//       </div>
//      </div>
//     </div>
//   );
// };

// export default AddStreamForm;




import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import config from "../config/config";

const AddStreamForm = () => {
  const navigate = useNavigate();
  const [colleges, setColleges] = useState([]);
  const [courses, setCourses] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState("");
  const [formData, setFormData] = useState({
    collegeId: "",
    courseId: "",
    courseName: "",
    streamsName: "",
    streamsFee: "",
    applicationDate: "",
    para1: "",
    table1: [
      { year: "", tutionFees: ["", ""], semWiseFees: ["", ""], yearlyFees: "" }
    ],
    para2: "",
    table2heading: "",
    table2para: "",
    table2: [
      { year: "", tutionFees: ["", ""], semWiseFees: ["", ""], yearlyFees: "" }
    ],
    cutoffHeading: "",
    cutoffPara: "",
    cutoffTable: [
      { catregory: "", round1: "", round2: "", round3: "", round4: "", round5: "", round6: "" }
    ],
    eligibilityCriteriaPara: "",
    courseDetailsPara: ""
  });

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}/api/admin/get_collegespage`)
      .then((res) => setColleges(res.data.collegePages || []))
      .catch((err) => console.error("Error fetching colleges:", err));
  }, []);

  const handleCollegeChange = async (e) => {
    const collegeId = e.target.value;
    setSelectedCollege(collegeId);
    setFormData({ ...formData, collegeId, courseId: "" });
    try {
      const response = await axios.get(`${config.API_BASE_URL}/api/admin/college_page_course_details/${collegeId}`);
      setCourses(Array.isArray(response.data.pageCourseDetails.coursesDeatils) ? response.data.pageCourseDetails.coursesDeatils : []);
    } catch (error) {
      setCourses([]);
    }
  };

  const handleCourseChange = (e) => {
    const courseId = e.target.value;
    const selectedCourse = courses.find(course => course._id === courseId);
    setFormData({ ...formData, courseId, courseName: selectedCourse?.courses || "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDynamicChange = (field, index, key, value, subIndex = null) => {
    const updatedList = [...formData[field]];
    if (subIndex !== null) {
      updatedList[index][key][subIndex] = value;
    } else {
      updatedList[index][key] = value;
    }
    setFormData({ ...formData, [field]: updatedList });
  };

  const handleAddRow = (field, defaultRow) => {
    setFormData({ ...formData, [field]: [...formData[field], defaultRow] });
  };

  const handleRemoveRow = (field, index) => {
    const updatedList = [...formData[field]];
    updatedList.splice(index, 1);
    setFormData({ ...formData, [field]: updatedList });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/admin/streams`, formData);
      if (res.data.code === 201) {
        alert("Stream added successfully!");
      } else {
        alert("Error creating course");
      }
    } catch (error) {
      console.error("Error adding stream:", error);
    }
  };

  return (
    <div className="container mt-5 pt-5">
      <div className="row">
        <div className="col-lg-2"></div>
        <div className="col-lg-10">


          <div className="row ms-5">
            <h2 className="mb-4">Add Stream</h2>
            <form onSubmit={handleSubmit} className="p-4 border rounded shadow">
              {/* Core Fields */}
              <div className="mb-3">
                <label>Select College:</label>
                <select className="form-control" value={selectedCollege} onChange={handleCollegeChange} required>
                  <option value="">Select</option>
                  {colleges.map(college => (
                    <option key={college._id} value={college._id}>{college.collegeName}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Select Course:</label>
                <select className="form-control" value={formData.courseId} onChange={handleCourseChange} required>
                  <option value="">Select</option>
                  {courses.map(course => (
                    <option key={course._id} value={course._id}>{course.courses}</option>
                  ))}
                </select>
              </div>
              <input name="streamsName" value={formData.streamsName} onChange={handleChange} className="form-control mb-3" placeholder="Stream Name" required />
              <input name="streamsFee" value={formData.streamsFee} onChange={handleChange} className="form-control mb-3" placeholder="Stream Fee" required />
              <input type="date" name="applicationDate" value={formData.applicationDate} onChange={handleChange} className="form-control mb-3" required />

              {/* Paragraphs */}
              <textarea name="para1" value={formData.para1} onChange={handleChange} className="form-control mb-3" placeholder="Para 1" required />

              {/* Table 1 */}

              <h6>Stream Inner page (Detail page)</h6>
              <h5>Table 1</h5>
              {formData.table1.map((row, index) => (
                <div key={index} className="border p-2 mb-2 rounded">
                  <input
                    className="form-control mb-1"
                    placeholder="Year"
                    value={row.year}
                    onChange={(e) => handleDynamicChange("table1", index, "year", e.target.value)}
                    required
                  />
                  {["tutionFees", "semWiseFees"].map((type) => (
                    <div className="row mb-2" key={type}>
                      {row[type].map((fee, i) => (
                        <div className="col-md-6" key={i}>
                          <label>
                            {type === "tutionFees" ? "Tuition Fee" : "Semester Fee"} Entry {i + 1}
                          </label>
                          <input
                            className="form-control"
                            value={fee}
                            placeholder={`Entry ${i + 1}`}
                            onChange={(e) =>
                              handleDynamicChange("table1", index, type, e.target.value, i)
                            }
                            required
                          />
                        </div>
                      ))}
                    </div>
                  ))}

                  <input
                    className="form-control mb-1"
                    placeholder="Yearly Fees"
                    value={row.yearlyFees}
                    onChange={(e) => handleDynamicChange("table1", index, "yearlyFees", e.target.value)}
                    required
                  />
                  {index > 0 && <button type="button" onClick={() => handleRemoveRow("table1", index)} className="btn btn-danger btn-sm">Remove</button>}
                </div>
              ))}
              <button type="button" className="btn btn-secondary mb-3" onClick={() =>
                handleAddRow("table1", { year: "", tutionFees: ["", ""], semWiseFees: ["", ""], yearlyFees: "" })
              }>Add Row</button>

              <textarea name="para2" value={formData.para2} onChange={handleChange} className="form-control mb-3" placeholder="Para 2" required />
              <input name="table2heading" value={formData.table2heading} onChange={handleChange} className="form-control mb-3" placeholder="Table 2 Heading" required />
              <textarea name="table2para" value={formData.table2para} onChange={handleChange} className="form-control mb-3" placeholder="Table 2 Paragraph" required />

              {/* Table 2 - Same as Table 1 */}
              <h5>Table 2</h5>
              {formData.table2.map((row, index) => (
                <div key={index} className="border p-2 mb-2 rounded">
                  <input
                    className="form-control mb-1"
                    placeholder="Year"
                    value={row.year}
                    onChange={(e) => handleDynamicChange("table2", index, "year", e.target.value)}
                    required
                  />
                  {["tutionFees", "semWiseFees"].map((type) => (
                    <div key={type}>
                      <label>{type === "tutionFees" ? "Tuition Fees" : "Semester Fees"}</label>
                      {row[type].map((fee, i) => (
                        <input
                          key={i}
                          className="form-control mb-1"
                          value={fee}
                          placeholder={`Entry ${i + 1}`}
                          onChange={(e) => handleDynamicChange("table2", index, type, e.target.value, i)}
                          required
                        />
                      ))}
                    </div>
                  ))}
                  <input
                    className="form-control mb-1"
                    placeholder="Yearly Fees"
                    value={row.yearlyFees}
                    onChange={(e) => handleDynamicChange("table2", index, "yearlyFees", e.target.value)}
                    required
                  />
                  {index > 0 && <button type="button" onClick={() => handleRemoveRow("table2", index)} className="btn btn-danger btn-sm">Remove</button>}
                </div>
              ))}
              <button type="button" className="btn btn-secondary mb-3" onClick={() =>
                handleAddRow("table2", { year: "", tutionFees: ["", ""], semWiseFees: ["", ""], yearlyFees: "" })
              }>Add Row</button>

              {/* Cutoff Section */}
              <h5>Cutoff Table</h5>
              <input name="cutoffHeading" value={formData.cutoffHeading} onChange={handleChange} className="form-control mb-3" placeholder="Cutoff Heading" required />
              <textarea name="cutoffPara" value={formData.cutoffPara} onChange={handleChange} className="form-control mb-3" placeholder="Cutoff Paragraph" required />

              {formData.cutoffTable.map((row, index) => (
                <div key={index} className="border p-2 mb-2 rounded">
                  <input className="form-control mb-1" placeholder="Category" value={row.catregory} onChange={(e) => handleDynamicChange("cutoffTable", index, "catregory", e.target.value)} required />
                  <div class="row px-3">
                    {[1, 2, 3, 4, 5, 6].map(r => (
                      <input key={r} className="form-control col-2 mb-1" placeholder={`Round ${r}`} value={row[`round${r}`]} onChange={(e) => handleDynamicChange("cutoffTable", index, `round${r}`, e.target.value)} />
                    ))}
                  </div>
                  {index > 0 && <button type="button" onClick={() => handleRemoveRow("cutoffTable", index)} className="btn btn-danger btn-sm">Remove</button>}
                </div>
              ))}
              <button type="button" className="btn btn-secondary mb-3" onClick={() =>
                handleAddRow("cutoffTable", { catregory: "", round1: "", round2: "", round3: "", round4: "", round5: "", round6: "" })
              }>Add Cutoff Row</button>

              {/* Eligibility & Course Details */}
              <textarea name="eligibilityCriteriaPara" value={formData.eligibilityCriteriaPara} onChange={handleChange} className="form-control mb-3" placeholder="Eligibility Criteria" required />
              <textarea name="courseDetailsPara" value={formData.courseDetailsPara} onChange={handleChange} className="form-control mb-3" placeholder="Course Details" required />

              <button type="submit" className="btn btn-primary">Add Stream</button>
            </form>
          </div>

        </div>

      </div>
    </div>
  );
};

export default AddStreamForm;
